var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-taxation-project-manage',{ref:"table",staticClass:"pt-taxation-project-manage__withData",on:{"deleteTax":_vm.deleteTax}})}
var staticRenderFns = []

export { render, staticRenderFns }